<template>
  <L1 class="customerUISetting">
  <template slot="slot_title">
      <div class="MessageSelect squr" label="">
        <input type="radio" v-model="MessageOrCoupon" value="預約成功">
        <input type="radio" v-model="MessageOrCoupon" value="通知付訂">
      </div>
  </template>
  <div class="content" v-if="accountInfo">
    <template v-if="MessageOrCoupon==='預約成功'">
    <div>
    <div class="contentHeader">付款資訊<EditBtn v-if="!editBook" @click="accountInfoEdit=accountInfo;editBook=true"></EditBtn></div>
    <textarea v-if="editBook" v-model="accountInfoEdit"></textarea>
    <div class="textarea" v-else v-html="accountInfo.replace(/\n/ig, '<br>')"></div>
    <div class="btns" v-if="editBook">
      <button class="cancel" @click="editBook=false">取消</button>
      <button class="confirm" @click="updateAccount">儲存</button>
    </div>
    <div class="contentHeader" :style="{marginTop: '20px'}">
      <span>預付訂金
        </span>
      <EditBtn v-if="!editPrepaid" @click="PrepaidDocentEdit=PrepaidDocent;PrepaidEditDate=PrepaidDate;PrepaidEdit=Prepaid;editPrepaid=true"></EditBtn>
    </div>
    <div class="PrepaidCube" v-if="!editPrepaid">
      預付訂金基本 <span :style="{color: 'var(--color-confirm)', fontWeight: 'bold', margin: '0 20px'}">{{Prepaid}}</span> 元,<br>
      根據導覽需求加上導覽員數量乘以<span :style="{color: 'var(--color-confirm)', fontWeight: 'bold', margin: '0 20px'}">{{PrepaidDocent}}</span> 元,<br>
      於預約前 <span :style="{color: 'var(--color-confirm)', fontWeight: 'bold', margin: '0 20px'}">{{PrepaidDate}}</span> 天前預付通知完畢。
      </div>
    <div class="PrepaidCube" v-else>
      預付訂金固定<input class="Prepaid" type="text" v-model="PrepaidEdit" :style="{width: '100px',margin: '0 20px'}">元,<br>
      根據導覽需求加上導覽員數量乘以<input class="Prepaid" type="text" v-model="PrepaidDocentEdit" :style="{width: '100px',margin: '0 20px'}"> 元,<br>
      於預約前<input class="Prepaid" type="text" v-model="PrepaidEditDate" :style="{width: '100px',margin: '0 20px'}">天前預付通知完畢。
    </div>
    <div class="btns" v-if="editPrepaid">
      <button class="cancel" @click="editPrepaid=false">取消</button>
      <button class="confirm" @click="updatePrepaid">儲存</button>
    </div>

    <div class="contentHeader" :style="{marginTop: '20px'}">
      <span>團體照片顯示
        </span>
      <EditBtn v-if="!editBarcode" @click="editBarcode=true"></EditBtn>
    </div>
    <template v-if="editBarcode">
      <div class="uploadimageBox">
        <label for="img2" id="uploadimage2" v-if="!barcodeImage">
          <div class="uploadimage2">
          <input type="file" id="img2" accept="image/png, image/jpeg" @change="uploadFile2($event, 'desc')" hidden>
          </div>
        </label>
        <div v-else @click="deleteImage2(barcodeImage)"><img :src="`.${barcodeImage}`"></div>
      </div>
      <div class="btns" :style="{marginRight: '30px', marginTop: '20px'}">
        <button class="cancel" @click="editBarcode=false">取消</button>
        <button class="confirm" @click="editBarcode=false">完成</button>
      </div>
    </template>
    <div v-else>
        <div class="uploadimageBox"><img :src="`.${barcodeImage}`"></div>
    </div>
    </div>
    <div class="content2">
      <div class="contentHeader" :style="{marginBottom: '13px'}">預約須知
        <EditBtn v-if="!editDescription" @click="editDescription=true"></EditBtn>
        <div class="btns" v-if="editDescription">
          <button class="cancel" @click="editDescription=false">取消</button>
          <button class="confirm" @click="updateDescription">儲存</button>
        </div>
      </div>
      <template v-if="editDescription">
      <div class="uploadimageBox">
        <label for="img" id="uploadimage" v-if="!bookDescImage">
          <div class="uploadimage">
          <input type="file" id="img" accept="image/png, image/jpeg" @change="uploadFile($event, 'desc')" hidden>
          </div>
        </label>
        <div v-else @click="deleteImage(bookDescImage)"><img :src="`.${bookDescImage}`"></div>
      </div>
      <div>
        <textarea v-model="bookDescription"></textarea>
      </div>
      </template>
      <div v-else class="bookDescription">
        <div class="uploadimageBox"><img :src="`.${bookDescImage}`"></div>
        <div :style="{marginTop: '40px'}" v-html="bookDescription.replace(/\n/ig, '<br>')"></div>
      </div>
    </div>
    </template>
    <template v-if="MessageOrCoupon==='通知付訂'">
    <div>
    <div class="contentHeader">付訂成功說明(一)<EditBtn v-if="!editNotifyPaidDesc1" @click="notifyPaidDesc1Edit=notifyPaidDesc1;editNotifyPaidDesc1=true"></EditBtn></div>
    <textarea v-if="editNotifyPaidDesc1" v-model="notifyPaidDesc1Edit"></textarea>
    <div class="textarea" v-else v-html="notifyPaidDesc1 ? notifyPaidDesc1.replace(/\n/ig, '<br>'): ''"></div>
    <div class="btns" v-if="editNotifyPaidDesc1">
      <button class="cancel" @click="editNotifyPaidDesc1=false">取消</button>
      <button class="confirm" @click="updatNotifyPaidDesc1">儲存</button>
    </div>
    </div>
    <div class="content2">
      <div class="contentHeader" :style="{marginBottom: '13px'}">付訂成功說明(二)
        <EditBtn v-if="!editNotifyPaidDesc2" @click="notifyPaidDesc2Edit=notifyPaidDesc2;editNotifyPaidDesc2=true"></EditBtn>
      </div>
      <textarea v-if="editNotifyPaidDesc2" v-model="notifyPaidDesc2Edit"></textarea>
      <div class="bookDescription" v-else :style="{marginTop: '20px'}" v-html="notifyPaidDesc2?notifyPaidDesc2.replace(/\n/ig, '<br>'): ''"></div>
      <div class="btns" v-if="editNotifyPaidDesc2">
        <button class="cancel" @click="editNotifyPaidDesc2=false">取消</button>
        <button class="confirm" @click="updatNotifyPaidDesc2">儲存</button>
      </div>
    </div>
    </template>
  </div>
</L1>
</template>

<script>
import L1 from '../../components/layout/L1.vue'
import EditBtn from '../../components/btn/edit.vue'
import { postapi, getapi, uploadimage, deleteapi } from '../../store/fetch'
export default {
  name: 'customerUISetting',
  components: {
    EditBtn,
    L1
  },
  data () {
    return {
      editBarcode: false,
      editDescription: false,
      editPrepaid: false,
      editBook: false,
      MessageOrCoupon: '預約成功',
      accountInfo: null,
      accountInfoEdit: null,
      Prepaid: 2000,
      PrepaidDocent: 500,
      PrepaidDate: 7,
      PrepaidEdit: null,
      PrepaidDocentEdit: null,
      bookDescription: '123',
      bookDescImage: null,
      barcodeImage: null,
      notifyPaidDesc1: '',
      notifyPaidDesc2: '',
      notifyPaidDesc1Edit: null,
      notifyPaidDesc2Edit: null,
      editNotifyPaidDesc1: false,
      editNotifyPaidDesc2: false
    }
  },
  async created () {
    await this.getInfo()
  },
  methods: {
    async deleteImage2 (filename) {
      const ret = await deleteapi(`images${filename}`)
      if (ret) {
        // console.log(ret, 'deleteImage')
        const ret2 = await postapi('selections/barcodeImage', { key: 'value', data: null })
        this.$nextTick(() => {
          this.barcodeImage = ret2
          // console.log(ret, 'deleteImage', ret2, this.barcodeImage)
        })
      }
    },
    async deleteImage (filename) {
      const ret = await deleteapi(`images${filename}`)
      if (ret) {
        // console.log(ret, 'deleteImage')
        const ret2 = await postapi('selections/bookDescImage', { key: 'value', data: null })
        this.$nextTick(() => {
          this.bookDescImage = ret2
          // console.log(ret, 'deleteImage', ret2, this.bookDescImage)
        })
      }
    },
    async uploadFile2 (event, folder) {
      const ret = await uploadimage(event, folder)
      if (ret) {
        const retDate = await postapi('selections/barcodeImage', { key: 'value', data: `/desc/${ret.filename}` })
        if (retDate) {
          this.barcodeImage = retDate
        }
      }
    },
    async uploadFile (event, folder) {
      const ret = await uploadimage(event, folder)
      if (ret) {
        const retDate = await postapi('selections/bookDescImage', { key: 'value', data: `/desc/${ret.filename}` })
        if (retDate) {
          this.bookDescImage = retDate
        }
      }
    },
    async getInfo () {
      this.accountInfo = await getapi('selections/accountInfo')
      this.Prepaid = await getapi('selections/Prepaid')
      this.PrepaidDate = await getapi('selections/PrepaidDate')
      this.PrepaidDocent = await getapi('selections/PrepaidDocent')
      this.bookDescription = await getapi('selections/bookDescription')
      this.bookDescImage = await getapi('selections/bookDescImage')
      this.barcodeImage = await getapi('selections/barcodeImage')
      this.notifyPaidDesc1 = await getapi('selections/notifyPaidDesc1')
      this.notifyPaidDesc2 = await getapi('selections/notifyPaidDesc2')
    },
    async updatNotifyPaidDesc1 () {
      const ret = await postapi('selections/notifyPaidDesc1', { key: 'value', data: this.notifyPaidDesc1Edit })
      if (ret) {
        this.notifyPaidDesc1 = ret
        this.editNotifyPaidDesc1 = false
      }
    },
    async updatNotifyPaidDesc2 () {
      const ret = await postapi('selections/notifyPaidDesc2', { key: 'value', data: this.notifyPaidDesc2Edit })
      if (ret) {
        this.notifyPaidDesc2 = ret
        this.editNotifyPaidDesc2 = false
      }
    },
    async updateDescription () {
      const ret = await postapi('selections/bookDescription', { key: 'value', data: this.bookDescription })
      if (ret) {
        this.bookDescription = ret
        this.editDescription = false
      }
    },
    async updatePrepaid () {
      const ret = await postapi('selections/Prepaid', { key: 'value', data: this.PrepaidEdit })
      const ret2 = await postapi('selections/PrepaidDocent', { key: 'value', data: this.PrepaidDocentEdit })
      const retDate = await postapi('selections/PrepaidDate', { key: 'value', data: this.PrepaidEditDate })
      if (ret && retDate) {
        this.Prepaid = ret
        this.PrepaidDocent = ret2
        this.PrepaidDate = retDate
        this.editPrepaid = false
      }
    },
    async updateAccount () {
      const ret = await postapi('selections/accountInfo', { data: this.accountInfoEdit })
      if (ret) {
        this.accountInfo = ret
        this.editBook = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bookDescription {
  text-align: start;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  i {
    font-style: normal;
    font-weight: 700;
    background-color: #FFFFFF!important;
    color: var(--color-phone-title);
  }
}
.content2 {
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 7px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    box-shadow: inset 0 0 6px #0000004d;
    background-color: var(--color-pri);
  }
  &::-webkit-scrollbar-track {
    border: none;
    border-radius: 20px;
    background-color: #d8d8d8;
    border: 2px solid #FFFFFF!important;
  }
}
.uploadimage2 {
  margin-right: auto;
  width: 516px;
  height: 240px;
  background-image: url(/upload2.svg);
  background-size: contain;
  display: inline-flex;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-position: left;
  position: relative;
  &::before {
    position: absolute;
    content: '匯入圖片';
    display: inline-flex;
    width: 100px;
    height: 35px;
    background-color: var(--color-checked);
    align-items: center;
    justify-content: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    left: 260px;
    top: 159px;
    transform: translateX(-50%);
  }
}
.uploadimage {
  margin-right: auto;
  width: 520px;
  height: 390px;
  background-image: url(/upload.svg);
  background-size: contain;
  display: inline-flex;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-position: left;
  position: relative;
  &::before {
    position: absolute;
    content: '匯入圖片';
    display: inline-flex;
    width: 100px;
    height: 35px;
    background-color: var(--color-checked);
    align-items: center;
    justify-content: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    left: 260px;
    top: 232px;
    transform: translateX(-50%);
  }
}
.uploadimageBox {
  img {
    resize: both;
    width: 520px;
  }
}
.uploadimageBox,
label#uploadimage {
  max-width: 520px;
}
.PrepaidCube {
  width: 100%;
  box-sizing: border-box;
  text-align: start;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 36px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
}
.Prepaid {
  width: 120px;
  height: 40px;
  margin-block: 21px;
  margin-right: 20px;
  border: 1px solid var(--color-border);
  border-radius: 3px;
  text-align: center;
  margin-top: 21px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-confirm);
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
.textarea {
  text-align: start;
  margin-top: 21px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
}
textarea {
  width: 100%;
  box-sizing: border-box;
  height: 390px;
  border: 1px solid var(--color-border);
  margin-top: 21px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  padding: 16px 20px;
  border-radius: 3px;
  margin-bottom: 21px;
}
.contentHeader {
  margin-bottom: 21px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  text-align: start;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 25px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
}
.content {
  display: grid;
  grid-template-columns: 645px 1fr;
}
.MessageSelect {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  &::before {
    content: attr(label);
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
  }
  input[type=radio] {
    &::before {
      content: attr(value);
    }
    background-color: #C4C4C4;
    color: #FFFFFF;
    &:checked {
      background-color: var(--color-checked);
      color: #FFFFFF;
    }
  }
  &.squr > input[type=radio] {
    border-radius: 3px;
    width: 125px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    appearance: none;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
  }
}
.customerUISetting {
  padding-inline: 18px 9px!important;
  height: 100vh;
  .content {
    display: grid;
    grid-template-columns: 645px 1fr;
    grid-template-rows: calc(100vh - 90px);
    &>:nth-child(1) {
      border-right: 1px solid var(--color-border);
    }
    &>div {
      width: 100%;
      height: 100%;
      padding-block: 28px;
      padding-inline: 50px;
      box-sizing: border-box;
    }
  }
 }
.header {
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 20px;
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
</style>
